/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 实名成功后返回的实名信息
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: member.IdentifyInfoRes;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/setting/identify/info`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
